import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import SubscriptionForm from './SubscriptionForm'

const stripePromise = loadStripe('pk_live_51QoERFJaMQuVGZe3z0XOcFQHnMxMKW9CpJDtpMwcTArXP6EDz5LD9flpSUAbd993y9nknHLAMu0ezNbJAXw6mZJG00nAqsSeht')

const StripeSubscription = ({profileId, accountEmail, type}) => {
    return (
        <Elements stripe={stripePromise}>
            <SubscriptionForm profileId={profileId} accountEmail={accountEmail} type={type} />
        </Elements>
    )
}

export default StripeSubscription